import React, { useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, GitMergeIcon } from 'lucide-react';
import { SlideToConfirm } from '../../ui/SlideToConfirm';
import { useDb } from '../../../hooks/useDb';
import { db } from '../../../utils/db';
import { contactById } from '../../../utils/dbSelectors';
export function DiffBody({
  onOpenGithub
}: {
  onOpenGithub: () => void;
}) {
  const {
    pr,
    files
  } = useDb(t => ({
    pr: t.pullRequests[0],
    files: t.diffs.filter(d => d.prId === t.pullRequests[0].id)
  }));
  const [open, setOpen] = useState<string[]>([files[0]?.path]);
  const add = pr.files.reduce((s, f) => s + f.additions, 0);
  const del = pr.files.reduce((s, f) => s + f.deletions, 0);
  return <div data-id="element-782" data-mp="1r3l7nkl3ixzn">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-783" data-mp="1r3uzzetm5h8i">
        <span className="font-mono text-[13px] text-ink-muted" data-id="element-784" data-mp="1m3fokssw6jt6">{pr.branch}</span>
        <span className="tabular-nums text-ink" data-id="element-785" data-mp="1m5jnsxfuiun4">
          <span className="text-[#8FD99A]" data-id="element-786" data-mp="1h5nmj5yj9hb9">+{add}</span> <span className="text-[#F29B8F]" data-id="element-787" data-mp="1h6yor1cbyh09">−{del}</span> · {pr.files.length} bestanden
        </span>
        <span className="flex items-center gap-1.5 text-[#8FD99A]" data-id="element-788" data-mp="poqgn9yf4dyq">
          <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-789" data-mp="uiuorwjf6s1e" /> {pr.tests.passed}/{pr.tests.passed + pr.tests.failed} tests geslaagd
        </span>
        {pr.status === 'goedgekeurd' && <span className="text-accent" data-id="element-790" data-mp="ksjk27rwwetg">Review goedgekeurd</span>}
      </div>
      <div className="mt-4 overflow-hidden rounded-2xl border border-white/[0.07] bg-night-950/60" data-id="element-791" data-mp="18hc9rmhxxqfm">
        {files.map(f => {
        const isOpen = open.includes(f.path);
        const meta = pr.files.find(x => x.path === f.path);
        return <div key={f.path} className="border-b border-white/[0.06] last:border-b-0" data-id="element-792" data-mp="ykzggpqb5ele">
              <button type="button" aria-expanded={isOpen} onClick={() => setOpen(o => isOpen ? o.filter(p => p !== f.path) : [...o, f.path])} className="flex w-full items-center gap-3 px-4 py-2.5 text-left transition-colors duration-150 hover:bg-white/[0.03]" data-id="element-793" data-mp="13g50fj05gj6u">
                <ChevronDownIcon className={`h-4 w-4 text-ink-muted transition-transform duration-150 ${isOpen ? '' : '-rotate-90'}`} aria-hidden data-id="element-794" data-mp="1ppva2s9k11r7" />
                <span className="min-w-0 flex-1 truncate font-mono text-[13px] text-ink" data-id="element-795" data-mp="1kxu1phfibv6g">{f.path}</span>
                <span className="font-mono text-[13px] tabular-nums" data-id="element-796" data-mp="1g0br7mlud7wc">
                  <span className="text-[#8FD99A]" data-id="element-797" data-mp="1b2jwkkttb7og">+{meta?.additions}</span> <span className="text-[#F29B8F]" data-id="element-798" data-mp="16zx3kglengpo">−{meta?.deletions}</span>
                </span>
              </button>
              {isOpen && <div className="overflow-x-auto pb-2 font-mono text-[13px] leading-6" data-id="element-799" data-mp="121ltq5v4167g">
                  <p className="px-4 text-ink-muted" data-id="element-800" data-mp="x2rbb5121jnv">{f.hunk}</p>
                  {f.lines.map((l, i) => <div key={i} className={`flex whitespace-pre ${l.type === 'add' ? 'bg-[#8FD99A]/10 text-[#C9F0CF]' : l.type === 'del' ? 'bg-[#F29B8F]/10 text-[#F6C9C2]' : 'text-ink-soft'}`} data-id="element-801" data-mp="2wdiregk5b8ay" data-mpi={i}>
                      <span className="w-12 shrink-0 select-none pr-3 text-right text-ink-muted" data-id="element-802" data-mp="33y2z3u3bvmjq">{l.n}</span>
                      <span className="w-4 shrink-0 select-none" data-id="element-803" data-mp="38ojidutty2e0">{l.type === 'add' ? '+' : l.type === 'del' ? '−' : ' '}</span>
                      <span data-id="element-804" data-mp="3dmurg3caw8v6">{l.text}</span>
                    </div>)}
                </div>}
            </div>;
      })}
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3" data-id="element-805" data-mp="2kyp3l7pya3r4">
        <p className="flex items-center gap-2 text-ink" data-id="element-806" data-mp="2l1blo1agw1nl">
          <GitMergeIcon className="h-4 w-4 text-ink-muted" aria-hidden data-id="element-807" data-mp="2pxsbr1188q3b" /> Mergen doe je zelf.
        </p>
        <button type="button" onClick={onOpenGithub} className="ml-auto h-10 whitespace-nowrap rounded-full border border-white/10 px-4 text-[14px] font-medium text-ink transition-colors duration-150 hover:border-white/25" data-id="element-808" data-mp="2uyg2rmpgh6xj">
          Open in GitHub
        </button>
      </div>
    </div>;
}
export function SlackBody({
  onPosted
}: {
  onPosted: () => void;
}) {
  const {
    msg,
    contact
  } = useDb(t => {
    const m = t.slackMessages[0];
    return {
      msg: m,
      contact: contactById(t, m.contactId)
    };
  });
  return <div data-id="element-809" data-mp="cs52ioad4a3k">
      <div className="rounded-2xl bg-white/[0.04] p-4" data-id="element-810" data-mp="crc5wg54b0z5">
        <p className="text-[13px] text-ink-muted" data-id="element-811" data-mp="ctyf0k7npojh">
          {contact?.name} · {msg.channel} · {msg.time}
        </p>
        <p className="mt-1 text-ink" data-id="element-812" data-mp="mq1c3bnniwzk">{msg.text}</p>
      </div>
      {msg.status === 'open' ? <div className="mt-4 flex gap-2" data-id="element-813" data-mp="10hg8qlahewp3">
          <button type="button" onClick={() => db.setSlack(msg.id, 'concept')} className="h-11 whitespace-nowrap rounded-full bg-ink px-5 text-[14px] font-semibold text-night-950 transition-colors duration-150 hover:bg-white" data-id="element-814" data-mp="10gelzjk3slrj">
            Ja, bereid voor
          </button>
        </div> : <div className="mt-4" data-id="element-815" data-mp="15eptvoqu8m74">
          <p className="text-[13px] font-medium text-ink-muted" data-id="element-816" data-mp="1p1t4xilwgrga">Concept-antwoord van Anna</p>
          <p className="mt-1 border-l-2 border-accent/50 pl-3 text-ink" data-id="element-817" data-mp="1t4fz3q61mogn">{msg.draftReply}</p>
          <div className="mt-4" data-id="element-818" data-mp="1f4exg8hyfd04">
            {msg.status === 'geplaatst' ? <p className="flex items-center gap-2 text-accent" data-id="element-819" data-mp="1f6iymiogxxwp">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-820" data-mp="1k1ojde64x6j7" /> Geplaatst in {msg.channel}
              </p> : <SlideToConfirm label="Schuif om te plaatsen" confirmedLabel="Geplaatst" onConfirm={() => {
          db.setSlack(msg.id, 'geplaatst');
          onPosted();
        }} data-id="element-821" data-mp="15cino06i9yg2" />}
          </div>
        </div>}
    </div>;
}
export function MailBody({
  onSent
}: {
  onSent: () => void;
}) {
  const {
    draft,
    original,
    proposal
  } = useDb(t => {
    const d = t.mailDrafts.find(x => x.id === 'd-bakker-reply');
    return {
      draft: d,
      original: t.mails.find(m => m.id === d?.mailId),
      proposal: t.proposals.find(p => p.id === 'p-mail-bakker')
    };
  });
  if (!draft) return null;
  const done = proposal?.status === 'goedgekeurd';
  return <div data-id="element-822" data-mp="3upthgpgy05y4">
      <dl className="grid grid-cols-[80px_1fr] gap-y-1 text-[14px]" data-id="element-823" data-mp="3unfp4odnd7u9">
        <dt className="text-ink-muted" data-id="element-824" data-mp="3prry03flu4m4">Aan</dt>
        <dd className="text-ink" data-id="element-825" data-mp="r8tf859q2pia">klant Bakker</dd>
        <dt className="text-ink-muted" data-id="element-826" data-mp="r7id09vxdpta">Onderwerp</dt>
        <dd className="text-ink" data-id="element-827" data-mp="m9qj5abpztmg">{draft.subject}</dd>
      </dl>
      <p className="mt-4 text-[13px] font-medium text-accent" data-id="element-828" data-mp="mai5rvncah0l">Geschreven door Anna</p>
      <p className="mt-1 border-l-2 border-accent/50 pl-3 text-ink" data-id="element-829" data-mp="h9c9jnuh0bmb">{draft.body}</p>
      {original && <>
          <p className="mt-4 text-[13px] font-medium text-ink-muted" data-id="element-830" data-mp="cbaq31t4uaab">Origineel · {original.received}</p>
          <p className="mt-1 border-l-2 border-white/15 pl-3" data-id="element-831" data-mp="31yrwg7qkjg6o">{original.snippet}</p>
        </>}
      <div className="mt-5" data-id="element-832" data-mp="2x3w75fcpv6x9">
        {done ? <p className="flex items-center gap-2 text-accent" data-id="element-833" data-mp="1ckimym06py1x">
            <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-834" data-mp="1hitugq30bwgz" /> Verstuurd
          </p> : <SlideToConfirm label="Schuif om te versturen" confirmedLabel="Verstuurd" onConfirm={() => {
        db.approveProposal('p-mail-bakker');
        onSent();
      }} data-id="element-835" data-mp="1mhx0acqta6q0" />}
      </div>
    </div>;
}